/** @format */
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { EventContext } from '../../Contexts/EventContext';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	name: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	gender: Yup.number()
		.typeError('انتخاب جنسیت الزامی است')
		.required('انتخاب جنسیت الزامی است'),
});

const EditField = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);

	useEffect(() => {
		const getField = async () => {
			setLoading(true);
			await useApi.get(
				`/sport-field/${id}`,
				{},
				(res) => {
					eventContext.sportField = res.data.data;
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('خطایی درهنگام دریافت اطلاعات پیش آمده است.');
				},
			);
		};
		getField();
	}, [id]);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.put(
			`/sport-field/${id}`,
			values,
			(res) => {
				success('رشته با موفقیت ایجاد شد');
				navigate('/panel/sport-field', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					name: eventContext.sportField.name,
					gender: eventContext.sportField.gender,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded p-2 mt-3'>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان رشته</label>
										<input
											name='name'
											value={values.name}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.name} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group '>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>جنسیت</label>
										<select
											className='form-control'
											name='gender'
											value={values.gender}
											onChange={handleChange}>
											<option value='0'>هردو</option>
											<option value='1'>مرد</option>
											<option value='2'>زن</option>
										</select>
										<ErrorMessage error={errors.gender} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<button className='btn btn-info btn-sm f-14'>
									{submitFormLoading ? (
										<div
											className='spinner-border spinner-border-sm text-white mb-1'
											role='status'></div>
									) : (
										'ثبت رشته'
									)}
								</button>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default EditField;
